export default __webpack_public_path__ + "static/2-9bbe1a85c554cfba5efecfa2e9a1127e.jpg";